module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/theme-blank.component.html
// module id = ./src/app/theme/theme-blank.component.html
// module chunks = main